import React, { useContext } from 'react';
import SectionMessage from '@atlaskit/section-message';

import { GlobalContext } from '../shared-components/common/GlobalContext';
import { CepPageHeader, TBreadcrumbsItem } from '../shared-components/stateless/CepPageHeader';
import { PageWrapper } from '../shared-components/stateless/layout/PageWrapper';

export const LicenseInvalidPage = () => {
  const { t } = useContext(GlobalContext);

  const breadcrumbItems: TBreadcrumbsItem[] = [
    {
      href: '/',
      i18n: 'license.breadcrumbTitle',
      params: [],
    },
  ];
  return (
    <PageWrapper>
      <CepPageHeader
        useNavigate={(_x: any) => null}
        pageTitle={t('license.pageTitle')}
        isLoading={false}
        breadcrumbItems={breadcrumbItems}
        helpUri={'/installation/'}
        helpContent={
          <>
            <p>{t('license.notice.paragraph1')}</p>
          </>
        }
      ></CepPageHeader>
      <SectionMessage title={t('license.errorTitle')} appearance="error">
        {t('license.errorMessage')}
      </SectionMessage>
    </PageWrapper>
  );
};
